import { render, staticRenderFns } from "./FormSuccessResult.vue?vue&type=template&id=0bd5e536&"
import script from "./FormSuccessResult.vue?vue&type=script&lang=js&"
export * from "./FormSuccessResult.vue?vue&type=script&lang=js&"
import style0 from "./FormSuccessResult.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/modules/shared/ui/public/forms/components/FormSuccessResult.vue
// module id = 376
// module chunks = 0